import React from "react";
import { QuoteDetails } from "../api/ApiTypes";
import {AtSign, User} from "lucide-react";
import {MetadataRow} from "./MetaDataRow.tsx";

interface ClientInfoSectionProps {
    client: QuoteDetails["client"];
}

const ClientInfoSection: React.FC<ClientInfoSectionProps> = ({ client }) => (
    <div className="space-y-2">
        <h3 className="font-medium text-slate-900">{client.companyName}</h3>
        <p className="text-slate-700 text-sm">{client.officeAddressLine}</p>

        {client.mainContactName && (
            <MetadataRow icon={<User className="hh-4 w-4 mr-1 text-blue-700" />} label='Email:' value={client.mainContactName}/>
        )}

        {client.mainContactEmailAddress && (
            <MetadataRow icon={<AtSign className="hh-4 w-4 mr-1 text-blue-700" />} label='Email:' value={client.mainContactEmailAddress}/>
        )}
    </div>
);

export default ClientInfoSection;
